//跳转页面
function toUrl(u) {
	location.href = u ? u : '/'
}

//获取URL参数
function getParam() {
	// URL地址
	const url = new URL(location.href);

	// 获取查询字符串部分并创建URLSearchParams对象
	const searchParams = new URLSearchParams(url.search);

	// 遍历所有参数名称和值，构造成对象形式返回
	const paramsObj = {};
	for (let param of searchParams) {
		const [key, value] = param;
		paramsObj[key] = value;
	}

	return paramsObj
}

//是否认证
function isRenzheng() {
	var userInfo = window.localStorage.getItem('GAOYANGNONGYE_PC_USERINFO')
	if (userInfo) {
		userInfo = JSON.parse(userInfo)
		if (userInfo.type != 0) {
			return true
		} else {
			return false
		}
	}
}

function left(i, j) {
	var j = -j;
	$("#gundong" + i).find("ul:first").animate({
		marginLeft: j
	}, 800, function() {
		$(this).css({
			marginLeft: "0px"
		}).find("li:first").appendTo(this);
	});
}

function right(i, j) {
	var j = -j;
	$("#gundong" + i).find("ul").css({
		marginLeft: j
	});
	$("#gundong" + i).find("ul").find("li:last").prependTo($("#gundong" + i).find("ul"));
	$("#gundong" + i).find("ul").animate({
		marginLeft: "0px"
	}, 800)
}

function auto(i, jj) {
	var picTimer;
	$("#gundong" + i).hover(function() {
		clearInterval(picTimer);
	}, function() {
		picTimer = setInterval(function() {
			left(i, jj);
		}, 3000);
	}).trigger("mouseleave");
}

/*
生成表单验证 rules
*/
function getRules(item) {
	//[{id:1,name:"单行文本"},{id:2,name:"邮箱"},{id:3,name:"手机"},{id:4,name:"多行文本"},{id:5,name:"整数"},{id:6,name:"小数"},{id:7,name:"金额"},{id:8,name:"文件"},{id:9,name:"图片"},{id:10,name:"时间"},{id:11,name:"单选下拉列表"},{id:12,name:"多选下拉列表"},{id:13,name:"自动编号"},{id:14,name:"区块"},{id:15,name:"地区"},{id:16,name:"电话"},{id:17,name:"网址"},{id:18,name:"日期"},]
	const rules = [];
	if (item.is_bitian) {
		rules.push({
			required: true,
			trigger: 'blur',
			message: item.xianshititle + '是必填项'
		})

		switch (item.type) {
			case 2:
				rules.push({
					type: 'email',
					message: item.xianshititle + '输入错误',
					trigger: ['blur', 'change'],
				})
				break;
			case 3:
				// rules.push({
				// 	type: 'number',
				// 	message: item.xianshititle + '输入错误',
				// 	trigger: ['blur', 'change'],
				// }, )
				break;
		}
	}

	return rules
}

//验证权限
function checkPer(e) {
	const juseId = localStorage.getItem('QISUGUOJI_Per_JueseId')
	if (juseId == 1) { //超级管理员
		return true
	} else {
		var quanxian = localStorage.getItem('QISUGUOJI_Per_Info')
		if (quanxian) {
			e = e.toString()
			quanxian = quanxian.split(',')
			// quanxian = quanxian.split(',')
			// console.log(quanxian)
			// console.log(quanxian.indexOf(e), e)
			if (quanxian.indexOf(e) != -1) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	}

}

//获取当前时间
function getDateTime(format = "YMDHIS") {
	const now = new Date();
	var year = now.getFullYear(); // 年份，例如：2021
	var month = now.getMonth() + 1; // 月份，范围是0-11，需要+1，例如：1月为1
	var day = now.getDate(); // 日期，例如：31
	var hours = now.getHours(); // 小时，24小时制，例如：23
	var minutes = now.getMinutes(); // 分钟，例如：59
	var seconds = now.getSeconds(); // 秒，例如：30

	month = month < 10 ? ('0' + month) : month;
	day = day < 10 ? ('0' + day) : day;
	hours = hours < 10 ? ('0' + hours) : hours;
	minutes = minutes < 10 ? ('0' + minutes) : minutes;
	seconds = seconds < 10 ? ('0' + seconds) : seconds;
	if (format == 'YMDHIS') {
		var time = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
	} else if (format == 'YMD') {
		var time = year + '' + month + '' + day
	} else if (format == 1) {
		var time = year + '年' + month + '月' + day + '日'
	}

	var days = now.getDay();
	switch (days) {
		case 1:
			days = '星期一';
			break;
		case 2:
			days = '星期二';
			break;
		case 3:
			days = '星期三';
			break;
		case 4:
			days = '星期四';
			break;
		case 5:
			days = '星期五';
			break;
		case 6:
			days = '星期六';
			break;
		case 0:
			days = '星期日';
			break;
	}
	if (format == 'arr') {
		return {
			year: year,
			month: month,
			day: day,
			hours: hours,
			minutes: minutes,
			seconds: seconds,
			days: days
		}
	} else {
		return time + ' ' + days;
	}

}


//判断上午下午
function getSXW() {
	var d = '',
		now = new Date(),
		hour = now.getHours();

	if (hour < 6) {
		d = '凌晨好！'
	} else if (hour < 9) {
		d = '早上好！'
	} else if (hour < 12) {
		d = '上午好！'
	} else if (hour < 14) {
		d = '中午好！'
	} else if (hour < 17) {
		d = '下午好！'
	} else if (hour < 19) {
		d = '傍晚好！'
	} else if (hour < 22) {
		d = '晚上好！'
	} else {
		d = '夜里好！'
	}
	return d
}

// import no_pic from '@/assets/images/no_pic.png'

function onImageError(event) {
	// event.target.src = no_pic
}


//验证登录
import toast from "@/components/toast/toast.js";
import http from '@/utils/request.js';
import baseUrl from '@/utils/baseUrl.js';

function checkLogin(e = 0) {

	let token = localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
	let userInfo = localStorage.getItem('GAOYANGNONGYE_PC_USERINFO')
	let userId = localStorage.getItem('GAOYANGNONGYE_PC_USERID')
	if (token && userInfo && userId) {

		return true
	} else {
		if (e == 0) {
			return false
		} else if (e == 1) {
			toast('请先登录');
		} else if (e == 2) {
			toast('请先登录');
			setTimeout(function() {
				location.href = "/#/login/login"
			}, 2000)
		} else if (e === 3) {
			location.href = "/#/login/login"
		}
	}

}
//秒转 年 时分秒
function secondsToDHMS(seconds, type = 0) {
	var days = Math.floor(seconds / (24 * 3600)); // 计算天数
	seconds %= (24 * 3600); // 剩余秒数
	var hours = Math.floor(seconds / 3600); // 计算小时
	seconds %= 3600; // 剩余秒数
	var minutes = Math.floor(seconds / 60); // 计算分钟
	minutes = minutes < 10 ? ('0' + minutes) : minutes

	seconds %= 60; // 剩余秒数
	seconds = seconds < 10 ? ('0' + seconds) : seconds
	if (type == 1) {
		return [days, hours, minutes, seconds]
	} else {
		return days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
	}

}
//手机号隐藏中间几位
function hidePhoneNumber(phoneNumber) {
	if (phoneNumber) {
		return (phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'));
	} else {
		return phoneNumber;
	}
}
//邮箱隐藏中间
function hideEmail(email) {
	if (String(email).indexOf('@') > 0) {
		var str = email.split('@'),
			_s = '';
		if (str[0].length > 3) {
			for (var i = 0; i < str[0].length - 3; i++) {
				_s += '*';
			}
		}
		var new_email = str[0].substr(0, 3) + _s + '@' + str[1]
	}
	return new_email
}


const common = {
	getParam: getParam,
	toUrl: toUrl,
	getRules: getRules,
	checkPer: checkPer,
	getDateTime: getDateTime,
	getSXW: getSXW,
	onImageError: onImageError,
	checkLogin: checkLogin,
	secondsToDHMS: secondsToDHMS,
	hidePhoneNumber: hidePhoneNumber,
	gdLeft: left,
	gdAuto: auto,
	gdRight: right,
	isRenzheng: isRenzheng,
	hideEmail: hideEmail


};

export default common;